import React from "react";
import { Row, Col, TextBox, Checkbox, Select } from "@countysuite/ui";
import { observer } from "mobx-react";
import { CaseEventCategoryRow } from "./caseEventCategories";
import { DefaultEventText } from "types/DefaultEventText";

interface Props {
  category: CaseEventCategoryRow;
  eventTexts?: DefaultEventText[];
  eventTextLkp: Map<number, DefaultEventText>;
}

export const CaseEventCategoryEditor: React.FC<Props> = observer(
  ({ category, eventTexts, eventTextLkp }) => {
    function setValueByName(e: any) {
      category.setValue(e.target.name, e.target.value);
    }

    function changeEventTextSelection(e: any) {
      const text = eventTextLkp.get(Number(e.target.value));
      if (text) {
        category.setValue(e.target.name, text.id);
        category.setValue("eventTextName", text.name);
        category.setValue("eventText", text.defaultValue);
      }
    }

    return (
      <Row>
        <Col xs={12} md={9}>
          <TextBox
            label="Name"
            name="name"
            onChange={setValueByName}
            value={category.name}
          />
        </Col>
        <Col xs={12} md={3}>
          <div style={{ marginTop: "6px" }}>
            <Checkbox
              onChange={(e: any) =>
                category.setValue("isVisible", !!e.target.checked)
              }
              checked={category.isVisible}
            >
              <strong>Visible</strong>
            </Checkbox>
          </div>
          <div style={{ marginTop: "6px" }}>
            <Checkbox
              onChange={(e: any) =>
                category.setValue("showOnPortal", !!e.target.checked)
              }
              checked={category.showOnPortal}
            >
              <strong>Show On E-Filing Portal</strong>
            </Checkbox>
          </div>
        </Col>
        <Col xs={12}>
          <Select
            label="Default Event Text"
            name="eventTextID"
            options={eventTexts}
            onChange={changeEventTextSelection}
            value={category.eventTextID}
          />
        </Col>
        <Col xs={12}>
          <TextBox
            label="Event Text (Name)"
            name="eventTextName"
            readOnly={category.eventTextID > 0}
            onChange={setValueByName}
            value={category.eventTextName}
          />
        </Col>
        <Col xs={12}>
          <TextBox
            label="Event Text (DefaultValue)"
            name="eventText"
            multiline
            rows={4}
            onChange={setValueByName}
            value={category.eventText}
          />
        </Col>
      </Row>
    );
  }
);
